<template>
    <b-container class=" v2_color_black">
        <b-row align-h="center" align-v="center">
            <b-col sm="12" class="my-3">
                <b-card no-body class="w-100 m-auto v2_box_teal">
                    <b-card-header
                        class="v2_font_size_24 v2_color_black v2_box_teal_header"
                    >
                        Review Job Opportunity
                    </b-card-header>
                    <b-card-body class="py-4 px-6">
                        <template v-if="!job_offer">
                            You don't have the active Job Offers
                        </template>
                        <template>
                            <div class="d-flex align-items-center mt-4 w-100">
                                <b-col cols="12" md="12" class="p-1 p-md-2">
                                    <div class="h-100 border_1 border_primary_teal p-1 p-md-2 p-xl-3">
                                        <div v-if="job_information">
                                            <b-row v-if="job_information.title" class="my-2">
                                                <b-col md="5">
                                                <span class="font-weight-bold">Job Title: </span>
                                                </b-col>
                                                <b-col md="7"> {{ job_information.title }} </b-col>
                                            </b-row>

                                            <b-row v-if="job_information.practice_name" class="my-2">
                                                <b-col md="5">
                                                <span class="font-weight-bold">Facility : </span>
                                                </b-col>
                                                <b-col md="7"> {{ job_information.practice_name }} </b-col>
                                            </b-row>

                                            <b-row v-if="job_information.city || job_information.state || job_information.address" class="my-2">
                                                <b-col md="5">
                                                    <span class="font-weight-bold">Address: </span>
                                                </b-col>
                                                <b-col md="7">
                                                    {{ job_information.city }} {{ job_information.state }} {{ job_information.address }}
                                                </b-col>
                                            </b-row>
                                            
                                            <b-row v-if="job_offer.location_zip_code" class="my-2">
                                                <b-col md="5">
                                                    <span class="font-weight-bold">Location: </span>
                                                </b-col>
                                                <b-col md="7">
                                                    {{ job_offer.location_zip_code }} 
                                                </b-col>
                                            </b-row>

                                            <b-row v-if="job_information.title" class="my-2">
                                                <b-col md="5">
                                                <span class="font-weight-bold">Job Opportunity Name: </span>
                                                </b-col>
                                                <b-col md="7"> {{ job_information.title }} </b-col>
                                            </b-row>
                                            

                                            <b-row v-if="job_information.description" class="my-2">
                                                <b-col md="5">
                                                    <span class="font-weight-bold">Job Title / Description: </span>
                                                </b-col>
                                                <b-col md="7">
                                                    {{ job_information.title }} {{ job_information.description }}
                                                </b-col>
                                            </b-row>

                                            <b-row v-if="job_information.about_us" class="my-2">
                                                <b-col md="5">
                                                <span class="font-weight-bold">About Us: </span>
                                                </b-col>
                                                <b-col md="7"> {{ job_information.about_us }} </b-col>
                                            </b-row>
                                            
                                            <b-row v-if="job_information.community_description" class="my-2">
                                                <b-col md="5">
                                                <span class="font-weight-bold">Community Description: </span>
                                                </b-col>
                                                <b-col md="7"> {{ job_information.community_description }} </b-col>
                                            </b-row>


                                            <b-row v-if="job_information.jobBoardUrl" class="my-2">
                                                <b-col md="5">
                                                    <span class="font-weight-bold">Job Link URL: </span>
                                                </b-col>
                                                <b-col md="7">                               
                                                    <a :href="job_information.jobBoardUrl" target="_blank">{{ job_information.jobBoardUrl }}</a>
                                                </b-col>
                                            </b-row>
                                        
                                            <b-row class="m-0">
                                                <b-col cols="12" md="12" class="p-1">
                                                    <div class="h-100 border_1 border_primary_teal p-1 p-md-2 p-xl-3">
                                                        <span class="font-weight-bold">Opportunity Details : </span>
                                                        
                                                        <b-row v-if="job_information.tracking" class="my-2">
                                                            <b-col md="5">
                                                                <span class="font-weight-bold">PO or Tracking #: </span>
                                                            </b-col>
                                                            <b-col md="7">  {{ job_information.tracking }}  </b-col>
                                                        </b-row>

                                                        <b-row v-if="job_information.company" class="my-2">
                                                            <b-col md="5">
                                                                <span class="font-weight-bold">Company: </span>
                                                            </b-col>
                                                            <b-col md="7">  {{ job_information.company }}  </b-col>
                                                        </b-row>

                                                        <b-row v-if="job_information.welcome_message" class="my-2">
                                                            <b-col md="5">
                                                                <span class="font-weight-bold">Welcome Message: </span>
                                                            </b-col>
                                                            <b-col md="7">  {{ job_information.welcome_message }}  </b-col>
                                                        </b-row>
                                                        
                                                        <b-row v-if="job_information.zipCode" class="my-2">
                                                            <b-col md="5">
                                                                <span class="font-weight-bold">Location Zip Code: </span>
                                                            </b-col>
                                                            <b-col md="7">  {{ job_information.zipCode }}  </b-col>
                                                        </b-row>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </div>  
                                        <b-row class="m-0">
                                            <b-col cols="12" md="12" class="p-1">
                                                <div class="h-100 border_1 border_primary_teal p-1 p-md-2 p-xl-3">
                                                    <span class="font-weight-bold">Opportunity Summary : </span>
                                                    <!-- <b-row v-if="specialtyName" class="my-2">
                                                        <b-col md="12">
                                                            <span class="font-weight-bold">Specialty: </span>
                                                        </b-col>
                                                        <b-col md="12"> {{ specialtyName }} </b-col>
                                                    </b-row>

                                                    <b-row v-if="specialtyName" class="my-2">
                                                        <b-col md="12">
                                                            <span class="font-weight-bold">Subspecialty: </span>
                                                        </b-col>
                                                        <b-col md="12"> {{ subspecialtyName }} </b-col>
                                                    </b-row> -->

                                                    <b-row class="my-2">
                                                        <b-col sm="12" md="12" lg="12">
                                                        <recruiter-review-ico-criteria-results
                                                            :criteria-items=this.$store.state.job_offer
                                                        />
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </b-col>
                                        </b-row>

                                        <b-row class="m-0">
                                            <b-col cols="12" md="12" class="p-1">
                                                <div class="h-100 border_1 border_primary_teal p-1 p-md-2 p-xl-3">
                                                    <span class="font-weight-bold">Contact Information : </span>
                                                    <b-row v-if="user.first_name" class="my-2">
                                                        <b-col md="5">
                                                            <span class="font-weight-bold">Name: </span>
                                                        </b-col>
                                                        <b-col md="7"> {{ user.first_name }} </b-col>
                                                    </b-row>

                                                    <b-row v-if="user.email" class="my-2">
                                                        <b-col md="5">
                                                            <span class="font-weight-bold">Email: </span>
                                                        </b-col>
                                                        <b-col md="7"> {{ user.email }} </b-col>
                                                    </b-row>

                                                    <b-row v-if="user.profile.phone_number" class="my-2">
                                                        <b-col md="5">
                                                            <span class="font-weight-bold">Phone: </span>
                                                        </b-col>
                                                        <b-col md="7"> {{ user.profile.phone_number }} </b-col>
                                                    </b-row>

                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </div>

                            
                        </template>
                        <b-form-row>
                            <b-col cols="6" class="text-right mt-3">
                                <b-button
                                variant="v2_main"
                                type="submit"
                                class="px-5"
                                @click="handleButtonClick('Back')"
                                >
                                <span>Back</span>
                                </b-button>
                            </b-col>
                            <b-col cols="6" class="d-flex justify-content-right mt-3">
                                <b-button v-if="this.$store.state.set_job_information==false"
                                variant="v2_main"
                                type="submit"
                                class="px-5"
                                @click="handleButtonClick('Next')"
                                >
                                <span>Next</span>
                                </b-button>
                            </b-col>
                        </b-form-row>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import RecruiterReviewJobCriteriaResult from '@/components/recruiter/ico/criteria/result/RecruiterReviewJobCriteriaResult';
import RecruiterReviewIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterReviewIcoCriteriaResults';

export default {
    name: 'RecruiterReviewJobOpportunityDetails',
    components: {
        RecruiterReviewJobCriteriaResult,
        RecruiterReviewIcoCriteriaResults,
  },
    data: function () {
        return {
            jobOffer: null,
            jobInformation: null,
            isLoading: false,
        };
    },
    created: function () {
        this.$store.state.set_job_information = false;
        //console.log(JSON.stringify(this.$store.state.job_offer));
        //console.log(JSON.stringify(this.$store.state.job_information));  
        // console.log(JSON.stringify(this.$store.state.user));
    },
    computed: {
        user: function () {
            return this.$store.state.user;
        },
        job_offer: function () {
            this.jobOffer = this.$store.state.job_offer;
            return this.$store.state.job_offer;
        },
        job_information: function () {
            return (this.$store.state.job_information ? this.$store.state.job_information : null);
        },
        specialty: function () {
            if (!this.$store.state.offer_specialty.specialtyId)
                return null;
            return (
                this.$store.state.specialtyOptions.find(
                (s) => s.value === this.$store.state.offer_specialty.specialtyId
                ) || {}
            ).specialty;        
        },
        specialtyName: function () {
            return (this.specialty || {}).title;
        },
        subspecialty: function () {
            if (!this.$store.state.offer_specialty.subspecialtyId)
                return null;
            return (
                this.$store.state.subspecialtyOptions.find(
                (s) => s.value === this.$store.state.offer_specialty.subspecialtyId
                ) || {}
            ).subspecialty;
        },
        subspecialtyName: function () {
            return (this.subspecialty || {}).title;
        },
    },
    methods: {
        handleButtonClick(label) {
        // Perform actions based on the button's label
            if (label === 'Next' && (!this.jobOffer || !this.jobOffer.is_payment_success)) {
                this.$router.push("/recruiter/purchase-job-offer");
            } else if (label === 'Back') {
                this.$store.state.set_job_information = true;
                // Do something for the "Back" button
                this.$router.push("/recruiter/profile");
            }
        },
        // getData: async function () {
        //     this.isLoading = true;
        //     try {
        //         this.jobOffer = this.$store.state.job_offer;
        //         this.jobInformation = this.$store.state.job_information;
        //         console.log(JSON.strigify(this.jobOffer));       
        //         console.log(JSON.strigify(this.jobInformation ));     
        //     } catch (e) {
        //     } finally {
        //         this.isLoading = false;
        //     }
        // },
    },
}
</script>